import { BestSellingProductsFilters } from "~src/pages/winningProducts/Products";
import { ApiTypes, api } from "../common";
import { BestSellingProductsPaginatedResults } from "~src/types/winningProducts";

const BEST_SELLING_PRODUCT_PATHS: ApiTypes.API = {
  bestSellingProducts: {
    path: `api/products/bestselling-products/`,
    method: ApiTypes.HTTPMethod.GET,
  },
};

export const getBestSellingProducts = async (
  page: number,
  page_size: number,
  filters: BestSellingProductsFilters | undefined,
  searchText: string | undefined,
  signal?: AbortSignal
) => {
  const endpoint = BEST_SELLING_PRODUCT_PATHS.bestSellingProducts;

  const params: { [key: string]: any } = {
    page,
    page_size,
    ...filters,
  };

  if (searchText) {
    params.search_text = searchText;
  }

  const response = await api<BestSellingProductsPaginatedResults>({
    method: endpoint.method,
    url: endpoint.path,
    params: params,
    signal,
  });
  return response.data;
};
